
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Screener = dynamic(() => import('features/pro-tools/Screener'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function ScreenerPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Screener Tools"
        description="Cari saham unggulan dengan mudah. Gunakan kriteria tertentu seperti harga saham, market cap, bunga deviden atau kriteria guru investasi dunia seperti Warren Buffett, Peter Lynch, Piotroski dan lainnya."
        url={`${siteUrl}/info/pro-tools/screener`}
      />
      <Screener />
    </HomePageLayout>
  );
}

export default ScreenerPage;
